export const DENTAL = {
  isHidden: true,
  nickname: 'PRODUCTS.DENTAL.nickname',
  icon:'dental'
};
